import React from 'react';

const GradientBackground = ({ 
    children, 
    className = "",
    fromColor = "#111827", // gray-900
    viaColor = "#1F2937", // gray-800
    toColor = "#111827", // gray-900
    direction = "to bottom right" // default direction
}) => {
    const getGradientDirection = (dir) => {
        switch(dir) {
            case 'r': return 'to right';
            case 'l': return 'to left';
            case 't': return 'to top';
            case 'b': return 'to bottom';
            case 'tr': return 'to top right';
            case 'tl': return 'to top left';
            case 'br': return 'to bottom right';
            case 'bl': return 'to bottom left';
            default: return 'to bottom right';
        }
    };

    return (
        <div className={`relative ${className}`}>
            <div 
                className="absolute inset-0"
                style={{
                    background: `linear-gradient(${getGradientDirection(direction)}, ${fromColor}, ${viaColor}, ${toColor})`,
                    backgroundSize: '200% 200%',
                    animation: 'gradient 15s ease infinite'
                }}
            ></div>
            <div className="relative z-10">
                {children}
            </div>
        </div>
    );
};

export default GradientBackground; 